import createClient from 'openapi-fetch'

import { getAccessToken } from '@/auth/token'

import type { paths } from './schema'

export const api = createClient<paths>({ baseUrl: '' })

api.use({
  async onRequest({ request }) {
    const token = getAccessToken()
    if (token) request.headers.set('authorization', `Bearer ${token}`)
    return request
  },
})
